import React from "react";

const SvgPolicy = props => (
  <svg data-name="Layer 1" viewBox="0 0 215 215" {...props}>
    <path
      d="M81.79 31.07L53.66 59.19l-.63.64v124.1H162V31.07zM159 180.93H56V61.75h27.71V34.07H159z"
      fill="currentColor"
    />
    <path
      d="M65.08 103.78a42.47 42.47 0 0040.1 42.35v15.22H92.11v4.72h31.45v-4.72H110.1v-15.24a42 42 0 0017-4.74L144.54 164l4.75-3.66-17-22.11a42.41 42.41 0 10-67.17-34.42zm78.84 0a36.47 36.47 0 01-33.82 36.32v-8.27c6.56-.68 12.47-3.36 15.74-8 8.38-11.88 2.65-33.24-1.51-44.92l-.8-2.24H91.46l-.8 2.24c-4.16 11.68-9.88 33-1.51 44.92 3.33 4.72 9.33 7.4 16 8v8.25a36.42 36.42 0 1138.74-36.34zM91.29 89.89c.94-3.48 2.16-7.2 2.95-9.42h26.92c.77 2.14 1.73 6.08 2.64 9.42z"
      fill="currentColor"
    />
  </svg>
);

export default SvgPolicy;